import { lazy } from 'react';

import IRoute from 'Shared/Routes/Models/IRoute';

import { BasicInfoPaths } from './BasicInfoPaths';

const RemindersListPage = lazy(() => import('Feature/BasicInfo/Reminder/RemindersList/Pages/RemindersListPage'));
const CreateReminder = lazy(() => import('Feature/BasicInfo/Reminder/CreateReminder/Pages/CreateReminder'));
const UpdateReminder = lazy(() => import('Feature/BasicInfo/Reminder/Update/Pages/UpdateReminder'));
const VahedHayeBimehListPage = lazy(() => import('Feature/BasicInfo/VahedHayeBimehList/Pages/VahedHayeBimehListPage'));

const BasicInfoRoutes: IRoute[][] = [
  [
    {
      path: BasicInfoPaths.Reminder.List,
      component: RemindersListPage,
      needAuth: true,
    },
    {
      path: BasicInfoPaths.Reminder.Create,
      component: CreateReminder,
      needAuth: true,
    },
    {
      path: BasicInfoPaths.Reminder.Update,
      component: UpdateReminder,
      needAuth: true,
      parameters: ['reminderId'],
    },
    {
      path: BasicInfoPaths.VahedBimeh.List,
      component: VahedHayeBimehListPage,
      needAuth: true,
    },
  ],
];

export default BasicInfoRoutes;
